/**
 * Translate description: Table component
 */

import { Fragment, useContext } from 'react';

import { useLanguageContext } from "../../../context/LanguageContext";
import AppContext from '../../../context/AppContext';

import Filter from '../../../components/filter/Filter';
import FilterSelect from '../../../components/filter/FilterSelect';
import DateFilter from '../../../components/filter/FilterDate';

import {
  ContentTable, ContentHeader, ContentHeaderItem, ContentBody,
  ContentBodyCheckbox, ContentBodyItem,
  ContentBodyItemImage, ContentBodyItemStatus, ContentBodyItemStatusCPA,
  ContentBodyItemTranslations, ContentBodyItemEdit
} from '../../../components/blocks/ContentTable';

import { ContentList, ContentListRow, ContentListItem } from '../../../components/blocks/ContentList';

import moment from 'moment/moment';

export default function Content() {
  const { t } = useLanguageContext();
  const { listItems } = useContext(AppContext);
  const { loading } = useContext(AppContext);

  return (
    <Fragment>
      <Filter fields={['store']}>
        <FilterSelect name="status_cpa" title="Status CPA" values={{
          pending: 'Pending',
          approved: 'Approved',
          declined: 'Declined',
        }} />
        <DateFilter />
      </Filter>

      <ContentTable>
        <ContentHeader>
          <ContentHeaderItem title={t('ID')} sortBy="id" width={50} />
          <ContentHeaderItem title={t('Store / User')} />
          <ContentHeaderItem title={t('Status')} width={100} />
          <ContentHeaderItem title={t('Status CPA')} width={100} />
          <ContentHeaderItem title={t('Ordered at')} sortBy="ordered_at" width={100} />
          <ContentHeaderItem title={t('Updated at')} sortBy="updated_at" width={100} />
          <ContentHeaderItem width={100}></ContentHeaderItem>
        </ContentHeader>

        <ContentBody colspan={8}>
          {(Array.isArray(listItems) && !loading && listItems?.length) ? (
            listItems.map((row) => (
              <tr key={row.id}>
                <ContentBodyCheckbox row={row} />
                <ContentBodyItem>{row.id}</ContentBodyItem>
                <ContentBodyItem to={`/order/${row.id}`}>{row.store?.name} / {row.user?.name || row.user?.login || row.catch_id || t('no user')}</ContentBodyItem>
                <ContentBodyItemStatus row={row} />
                <ContentBodyItem>{row.status_cpa}</ContentBodyItem>
                <ContentBodyItem>{moment(row.ordered_at).format('YYYY-MM-DD HH:mm:ss')}</ContentBodyItem>
                <ContentBodyItem>{moment(row.updated_at).format('YYYY-MM-DD HH:mm:ss')}</ContentBodyItem>
                <ContentBodyItemEdit row={row} addLink='orders' editLink='order' deleteLink='orders' />
              </tr>
            ))
          ) : null}
        </ContentBody>
      </ContentTable>

      <ContentList>
        {(Array.isArray(listItems) && !loading && listItems?.length) ? (
          listItems.map((row) => (
            <ContentListRow key={row.id} row={row} editLink={'order'} deleteLink={'orders'}>
              <ContentListItem>{row.id}</ContentListItem>
            </ContentListRow>
          ))
        ) : null}
      </ContentList>

    </Fragment >
  );
}